// extracted by mini-css-extract-plugin
export default {"gradient1":"P_gradient1__LkpB-","gradient2":"P_gradient2__HTfe-","gradientTextBlack":"P_gradientTextBlack__ZIURS"};